import { createContext } from 'react';

export const IssuesContext = createContext<IssuesContextProps>({
	isMenuOpen: false,
	setIsMenuOpen: () => {},
	toggleMenu: () => {},
});

interface IssuesContextProps {
	isMenuOpen: boolean;
	setIsMenuOpen: (value: boolean) => void;
	toggleMenu: Function;
}
